goog.provide('el8.appchart.actions.prenatalFlowsheets');

goog.require('el8.appchart.permissions');
goog.require('el8.ptdata.prenatalFlowsheets');

goog.require('el8.appchart.dialog.prenatalFlowsheet');

el8.appchart.actions.prenatalFlowsheets = function(opts) {

    opts = opts || {};
    var item = opts.item;
    var menu = [];

    if (el8Globals.TEASE) {
        return [];
    }
    var menu = [];

    menu.push({
        actionText: item.getEndDate() ? 'Reopen' : 'Edit',
        actionFn: function() {
            el8.appchart.dialog.prenatalFlowsheet.show({'ptPrenatalFlowsheet': item});
        }
    });
    menu.push({
        actionText: 'Print',
        actionFn: function() {
            item.print();
        }
    });
    menu.push({
        actionText: 'Delete',
        actionFn: function() {
            el8.uiwidget.deleteConfirm(
                'flowsheet',
                function() { 
                    el8.ptdata.prenatalFlowsheets.deleteItem(
                        item, 
                        false, 
                        {
                            successCb: function() {
                                el8.appchart.mainFeeds.reqAct.update();
                            }
                        }
                    );  
                }
            );
        }
    });

    return menu;
};